import { addClass, removeClass, toggleClass, wootOn } from './DOMHelpers';
import { IFrameHelper } from './IFrameHelper';
import { isExpandedView } from './settingsHelper';

export const bubbleImg = "data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 48 48' height='48' width='48'%3e%3cpath fill='%23FFFFFF' d='M1.5 22C1.5 10.6782 10.6782 1.5 22 1.5C32.9938 1.5 41.9663 10.154 42.4771 21.0214C40.041 19.427 37.1288 18.5 34 18.5C25.4396 18.5 18.5 25.4396 18.5 34C18.5 37.1288 19.427 40.041 21.0214 42.477C17.5197 42.3124 14.2467 41.2689 11.4195 39.562C9.33775 40.3998 6.94811 41.2705 4.76175 41.8775C3.1048 42.3376 1.6116 40.9133 2.03127 39.2326C2.5978 36.9637 3.46969 34.5113 4.33595 32.4097C2.53391 29.3582 1.5 25.7991 1.5 22Z'%3e%3c/path%3e%3cpath fill='%23FFFFFF' d='M34 21.5C40.9036 21.5 46.5 27.0964 46.5 34C46.5 36.3007 45.878 38.4576 44.7927 40.31C45.1937 41.181 45.5877 42.1677 45.9053 43.2217C46.4119 44.9031 44.882 46.3551 43.2303 45.8151C42.229 45.4877 41.2798 45.1021 40.4284 44.7224C38.5498 45.8511 36.35 46.5 34 46.5C27.0964 46.5 21.5 40.9036 21.5 34C21.5 27.0964 27.0964 21.5 34 21.5Z'%3e%3c/path%3e%3c/svg%3e";

export const body = document.getElementsByTagName('body')[0];
export const widgetHolder = document.createElement('div');

export const bubbleHolder = document.createElement('div');
export const chatBubble = document.createElement('button');
export const closeBubble = document.createElement('button');
export const notificationBubble = document.createElement('span');

export const setBubbleText = bubbleText => {
  if (isExpandedView(window.$chatwoot.type)) {
    const textNode = document.getElementById('woot-widget--expanded__text');
    textNode.innerHTML = bubbleText;
  }
};

export const createBubbleIcon = ({ className, src, target }) => {
  let bubbleClassName = `${className} woot-elements--${window.$chatwoot.position}`;
  const bubbleIcon = document.createElement('img');
  bubbleIcon.src = src;
  bubbleIcon.alt = 'bubble-icon';
  target.appendChild(bubbleIcon);

  if (isExpandedView(window.$chatwoot.type)) {
    const textNode = document.createElement('div');
    textNode.id = 'woot-widget--expanded__text';
    textNode.innerHTML = '';
    target.appendChild(textNode);
    bubbleClassName += ' woot-widget--expanded';
  }

  target.className = bubbleClassName;
  return target;
};

export const createBubbleHolder = () => {
  addClass(bubbleHolder, 'woot--bubble-holder');
  body.appendChild(bubbleHolder);
};

export const createNotificationBubble = () => {
  addClass(notificationBubble, 'woot--notification');
  return notificationBubble;
};

export const onBubbleClick = (props = {}) => {
  const { toggleValue } = props;
  const { isOpen } = window.$chatwoot;
  if (isOpen !== toggleValue) {
    const newIsOpen = toggleValue === undefined ? !isOpen : toggleValue;
    window.$chatwoot.isOpen = newIsOpen;

    toggleClass(chatBubble, 'woot--hide');
    toggleClass(closeBubble, 'woot--hide');
    toggleClass(widgetHolder, 'woot--hide');
    IFrameHelper.events.onBubbleToggle(newIsOpen);

    if (!newIsOpen) {
      chatBubble.focus();
    }
  }
};

export const onClickChatBubble = () => {
  wootOn(bubbleHolder, 'click', onBubbleClick);
};

export const addUnreadClass = () => {
  const holderEl = document.querySelector('.woot-widget-holder');
  addClass(holderEl, 'has-unread-view');
};

export const removeUnreadClass = () => {
  const holderEl = document.querySelector('.woot-widget-holder');
  removeClass(holderEl, 'has-unread-view');
};
